import { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-north-1_jnEz06lpR',
      userPoolClientId: '29187dn89tfcqk2juegmtq26sv',
      loginWith: {
        oauth: {
          domain: 'go-tailor.auth.eu-north-1.amazoncognito.com',
          scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: ['https://tailor.go.entail.io/'],
          redirectSignOut: ['https://tailor.go.entail.io/'],
          responseType: 'code',
        },
      },
    },
  },
};
export default amplifyConfig;
